declare const gmapsKey: string;
declare const aedList: {
    aedList: AedDataType[],
};

type AedDataType = {
    id: number|null,
    name: string,
    address: string,
    zip: string|null,
    city: string|null,
    divisionName: string|null,
    lat: string,
    lng: string,
};

export function initAedForm() : void {
    const $aedForms = document.querySelectorAll<HTMLFormElement>('.js-aed-form');

    $aedForms.forEach($aedForm => {
        new AedForm($aedForm);
    });
}

class AedForm {
    $form: HTMLFormElement;
    $divisionSelect: HTMLSelectElement;
    $aeds: NodeListOf<HTMLElement>;
    $aedMap: HTMLElement;
    aedMap: google.maps.Map|null = null;
    aedMarkers: google.maps.Marker[] = [];
    bounds: google.maps.LatLngBounds|null = null;

    constructor($form: HTMLFormElement) {
        this.$form = $form;
        this.$divisionSelect = this.$form.querySelector('.js-division-select') as HTMLSelectElement;
        this.$aeds = this.$form.querySelectorAll<HTMLElement>('.js-aed');
        this.$aedMap = this.$form.querySelector('.js-aed-map') as HTMLElement;

        if ('undefined' !== typeof gmapsKey) {
            this.aedMap = new google.maps.Map(this.$aedMap, {
                zoom: 4,
                center: new google.maps.LatLng(46.1313741, -2.4359996),
                mapTypeId: google.maps.MapTypeId.TERRAIN,
            });
        }

        this.addFormEvents();
    }

    /**
     * Add events on form fields
     * 
     * @return {void}
     */
    addFormEvents() : void {
        this.changeDivisionHandler();
        this.$divisionSelect.addEventListener('change', () => this.changeDivisionHandler());
    }

    /**
     * On change division select
     * 
     * @return {void}
     */
    changeDivisionHandler() : void {
        const divisionSelected = this.$divisionSelect.value;

        this.$aeds.forEach($aed => {
            if (divisionSelected === $aed.dataset.division) {
                $aed.classList.remove('hidden');
            } else {
                $aed.classList.add('hidden');
                ($aed.querySelector('input') as HTMLInputElement).checked = false;
            }
        });

        this.bounds = new google.maps.LatLngBounds();

        // Remove old markers
        this.aedMarkers.forEach(marker => {
            marker.setMap(null);
        });

        // Add new markers
        aedList.aedList.forEach(aedData => {
            if (divisionSelected === aedData.divisionName) {
                this.addMarker(aedData);
            }
        });

        if (this.aedMap) {
            // Center the map
            this.aedMap.fitBounds(this.bounds);

            // Set the map zoom level
            google.maps.event.addListenerOnce(this.aedMap, 'bounds_changed', () => {
                if (this.aedMap && (this.aedMap.getZoom() || 12) > 8) {
                    this.aedMap.setZoom(8);
                }
            });
        }
    }

    /**
     * Add a marker into aedMap
     * 
     * @param {AedDataType} aedData 
     * 
     * @return {void}
     */
    addMarker(aedData: AedDataType) : void {
        const contentString = '<div id="content">' +
            '<h4 id="firstHeading" class="firstHeading">' + aedData.name + '</h4>' +
            '<div id="bodyContent">' +
                '<p><b>Adresse</b> : ' + aedData.address + ' ' + aedData.zip + ' ' + aedData.city + '<br>' +
                '<b>Département</b> : ' + aedData.divisionName +
            '</div>' +
        '</div>';

        const infowindow = new google.maps.InfoWindow({
            content: contentString,
        });

        const aedCoordonnees = {
            lat: Number(aedData.lat),
            lng: Number(aedData.lng),
        };

        const marker = new google.maps.Marker({
            position: aedCoordonnees,
            map: this.aedMap,
            title: aedData.name,
        });

        this.aedMarkers.push(marker);
        this.bounds?.extend(marker.getPosition() as google.maps.LatLng);

        marker.addListener('click', () => {
            infowindow.open(this.aedMap, marker);
        });
    }
}
